<template>
  <v-container  style="max-width: 100%">
    <v-row no-gutters>
      <v-col>
        <v-card class="pa-2" elevation="0">
          <h1>{{ $t("catalogs_groups.title") }}</h1>
          <email-confirmation-reminder/>
          <v-progress-linear
              indeterminate
              reverse
              v-show="!isFetchedSites || !isFetchedClientCatalogGroups"
              class="my-2"
          ></v-progress-linear>
          <v-breadcrumbs
              class="px-0"
              :items="[{
                      text: $t('sites.title'),
                      disabled: false,
                      href: '/',
                    },
                    {
                      text: selectedSite && selectedSite.domain,
                      disabled: true
                    }]"
              large
          ></v-breadcrumbs>
          <v-container   style="max-width: 100%">
            <v-row>
              <v-col cols="12" md="4" v-for="clientCatalogGroup in clientCatalogGroups" :key="clientCatalogGroup.id" class="pl-0 pb-0 pt-2 px-2">
                <v-card  outlined>
                  <v-card-text>
                    <v-row @click="toggleExpandedClientCatalogGroup(clientCatalogGroup.id)" class="pointer">
                    <v-col cols="6" >
                      <v-img
                          class="d-inline-flex"
                          max-height="45"
                          max-width="45"
                          :src="logoPath+catalogGroup.logo"
                          v-for="catalogGroup in clientCatalogGroup.catalog_groups"
                          :key="catalogGroup.id"></v-img>
                    </v-col>
                    <v-col cols="6" class="d-flex pl-0 ml-0">
                      <v-spacer></v-spacer>
                      <v-chip outlined label small class="mr-2" v-if="clientCatalogGroup.status==1">{{clientCatalogGroup.bill_end}}</v-chip>
                      <v-chip label small color="success" v-if="clientCatalogGroup.status==1">{{ $t('common.is_enabled') }}</v-chip>
                      <v-chip label small color="error" v-else>{{ $t('common.is_disabled') }}</v-chip>
                    </v-col>
                  </v-row>
                    <v-expand-transition>
                      <div v-show="expandedClientCatalogGroup.includes(clientCatalogGroup.id)" class="catalogs-wrap">
                        <v-divider></v-divider>

                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">
                                {{ $t('catalogs_groups.catalog') }}
                              </th>
                              <th class="text-left">
                                {{ $t('catalogs_groups.link_to_catalog') }}
                              </th>
                              <th class="text-left">
                                {{ $t('catalogs_groups.code_for_site') }}
                              </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="catalogGroup in clientCatalogGroup.catalog_groups"
                                :key="catalogGroup.id"
                            >
                              <td class="d-flex align-center" >
                                <v-img

                                    max-height="40"
                                    max-width="40"
                                    :src="logoPath+catalogGroup.logo"
                                    :title="catalogGroup.name"
                                    :key="catalogGroup.id"></v-img>
                                <span class="d-flex">
                                {{catalogGroup.name}}
                                  </span>
                              </td>
                              <td>
                                <a class="" target="_blank" :href="'https://' + catalogGroup.url_name + '.catalogs-parts.com/' + catalogGroup.url_shablon.replace('*sait_id*', clientCatalogGroup.sait_code).replace('*lang*', clientCatalogGroup.group_lang)">
                                  {{ $t('catalogs_groups.link_to_catalog') }}
                                  <v-icon x-small>mdi-open-in-new</v-icon>
                                </a>
                              </td>
                              <td>
                                <a href="#" @click.stop="showCodeWindow(catalogGroup, clientCatalogGroup)">
                                  {{ $t('catalogs_groups.code_for_site') }}
                                  <v-icon x-small>mdi-code-tags</v-icon>
                                </a>
                              </td>



<!--                              <td style='vertical-align: middle'>-->

<!--                                <a target='_blank' href='" . $cat_link . "'>".trans($trans,'Ссылка на каталог')." <span class=\"glyphicon glyphicon-share-alt\"></span></a>-->

<!--                              </td>-->

<!--                              <td style='vertical-align: middle'>-->

<!--                                <a href=\"javascript:code_show('" . $cat->logo . "','" . $cat->name . "','" . $cat_link_short . "')\">".trans($trans,'Код для вставки на сайт')." <span class=\"glyphicon glyphicon-indent-left\"></a>-->

<!--                              </td>-->
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <code-window :link="codeWindow.link" :image="codeWindow.image" :is-visible="codeWindow.isVisible" @hide="codeWindow.link = null;codeWindow.isVisible=false;"/>
  </v-container>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CodeWindow from "@/components/CodeWindow";
import EmailConfirmationReminder from "../components/EmailConfirmationReminder.vue";

export default {
  name: "Catalogs_groups",
  components: {EmailConfirmationReminder, CodeWindow},
  data: () => ({
    codeWindow:{
      isVisible: false,
      link:null,
      image:null,
    },
    selectedSite:null,
    logoPath: process.env.VUE_APP_BRANDS_MINI_PATH,
    expandedClientCatalogGroup:[]
  }),
  mounted() {
    this.$store.dispatch("sites/fetch").then(()=>{
      if(this.sites){
        this.selectedSite = this.sites.find((site)=> parseInt(site.id) === parseInt(this.$route.params.site_id))
      }
    })
  },
  computed: {
    ...mapFields("client_catalog_groups", [
      "isFetchedClientCatalogGroups",
      "clientCatalogGroups"
    ]),
    ...mapFields("sites", [
      "nowProcessingSiteWithId",
      "sites",
      "savingInProgress",
      "isFetchedSites",
    ]),
  },
  watch:{
    selectedSite(site){
      this.$store.dispatch("client_catalog_groups/fetch",{sait_code:site.sait_code}).then(()=>{

      })
    }
  },
  methods: {
    showCodeWindow(catalogGroup, clientCatalogGroup){
      this.codeWindow.isVisible = true;
      this.codeWindow.link = 'https://' + catalogGroup.url_name + '.catalogs-parts.com/' + catalogGroup.url_shablon.replace('*sait_id*', clientCatalogGroup.sait_code).replace('*lang*', clientCatalogGroup.group_lang)
      this.codeWindow.image = this.logoPath+catalogGroup.logo
    },
    toggleExpandedClientCatalogGroup(id){
        if (this.expandedClientCatalogGroup.filter(i => i == id).length) {
          this.expandedClientCatalogGroup = this.expandedClientCatalogGroup.filter(i => i !== id);
        } else {
          this.expandedClientCatalogGroup.push(id)
        }
      },
  },
};
</script>

<style lang="scss">
  .catalogs-wrap {
    a:hover {
      text-decoration: underline;
    }

    a {
      text-decoration: none;
    }
  }
</style>